import React, { useState, useEffect } from 'react'
import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { useForm } from "react-hook-form";
import { useSectionStore } from "../../stores"
import "bootstrap/dist/css/bootstrap.min.css";

const EditModalAdmin = ({ show, onClose, onSend, onUpdate, isNew }) => {
    // const defaultValues = {};
    const { register, handleSubmit, watch, formState: { errors }, unregister, reset } = useForm({ shouldUnregister: true });
    const branch = useSectionStore(state=>state.branch);
    const duration = branch.degree ? branch.degree.duration:0;
    const row = useSectionStore(state => state.tempRow);
    const section = row;
    useEffect(() => {
        if (show) {
            reset(row);
        }
    }, [show]);
    const onSubmit = (data) => {
        data = { ...data, ...data.coo, _id: row._id };
        console.log(data);
        if (isNew) {
            onSend(data);
        }
        else {
            onUpdate(data);
        }
    }
    return (
        <>
            <Modal show={show} onHide={() => onClose()} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Faculty details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className="mb-3" controlId="degree">
                            <Form.Label>Section's Name</Form.Label>
                            <Form.Control type="text" defaultValue={section.name} {...register("name")} placeholder="Enter section name" />
                        </Form.Group>
                        <div className='row mb-3'>
                            <Form.Group className="col-6" controlId="degree">
                                <Form.Label>Year</Form.Label>
                                <Form.Select className="addS" defaultValue={section.year} disabled={!isNew} {...register("year")}>
                                    {
                                        Array.from({length:duration}).map((d,index)=><option value={index+1}>{index+1}</option>)
                                    }
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="col-6" controlId="degree">
                                <Form.Label>Sem</Form.Label>
                                <Form.Select className="addS" defaultValue={section.sem} {...register("sem")}>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                        <Form.Group className="mb-3" controlId="degree">
                            <Form.Label>Faculty name</Form.Label>
                            <Form.Control type="text" defaultValue={""} {...register("firstName")} placeholder="Enter faculty name" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="years">
                            <Form.Label>Faculty email</Form.Label>
                            <Form.Control type="email" defaultValue={section.email} {...register("coo.email")} placeholder="Email" />
                        </Form.Group>
                        <div className='d-flex justify-content-center'>
                        <Button  type="submit" className='modalbutton'>
                            Send invitation
                        </Button>
                        </div>
                        
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditModalAdmin



